var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-alert-area"},_vm._l((_vm.errorObjList),function(error){return _c('b-alert',{key:error.id,staticStyle:{"white-space":"pre-wrap"},attrs:{"variant":"danger","show":"","dismissible":""}},[_vm._v(_vm._s(error.msg))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }